import { useEventUser } from 'hooks/queries/events';
import { useSearchFriends } from 'hooks/queries/friends';
import { useState } from 'react';
import { useForm } from 'react-hook-form';

const useEventAddUserModal = (eventId: string) => {
  const [selectedUniqueId, setSelectedUniqueId] = useState();
  const formMethods = useForm({
    mode: 'onSubmit',
  });

  const handleSubmit = formMethods.handleSubmit(({ uniqueId }) => {
    setSelectedUniqueId(uniqueId);
  });

  const { postEventUser } = useEventUser();

  const {
    queryResult: { data },
  } = useSearchFriends(selectedUniqueId);

  const handleAddUser = () => {
    postEventUser.mutate({
      eventId,
      status: 'VALIDATED',
      userId: data?.['@id'] || '',
      successMessage: 'event.addUser.success',
    });
  };

  return { handleSubmit, formMethods, data, handleAddUser };
};

export default useEventAddUserModal;
